<template>
    <general-input
        ref="accrualDurationInputRef"
        v-model="line.accrualDuration"
        data-cy="trans-entry-accrual-duration"
        placeholder="Antall måneder"
        type="number"
    />
</template>

<script setup lang="ts">
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import GeneralInput from '@/components/GeneralInput.vue'

const line = defineModel<TransactionEntryLine>({required: true})

</script>

<style scoped>

</style>